/*                                 */
import { noop } from '../shared/utils.js';

import { BROWSER } from 'esm-env';

const now = BROWSER ? () => performance.now() : () => Date.now();

/*              */
export const raf = {
	/*                                                        */
	/*                                                   */
	/*                                                               */
	tick: /*                 */ (_) => (BROWSER ? requestAnimationFrame : noop)(_),
	now: () => now(),
	tasks: new Set()
};
